/* Section titles, Option A "Terminal".

   Six labels only, matched by their exact text. This is deliberately narrow.

   A previous version of this script also swept the page for anything already
   wearing the same blue and restyled that too. It caught the order references,
   the deal table headers, the close dates and the Gift Lab prices, made them
   40% larger and broke the tables. Do not reintroduce a colour sweep here. If
   another label needs the treatment, add its text to LABELS.

   Anything inside a table, the header, the nav or the footer is refused
   outright, as a second line of defence, and the element has to be a kicker or
   an eyebrow, so a heading that happens to share the wording is left alone. */
(function () {
  var LABELS = ['Design Studio', 'Navigator', 'Playbooks', 'Outbox HQ', 'ROI', 'Flight Deck'];
  var SCAN = 'span,div,h1,h2,h3,h4,h5,h6,p,strong,b,figcaption';

  function text(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function eligible(el) {
    if (el.closest('header, nav, footer')) return false;
    if (el.closest('table, thead, tbody, tr, th, td')) return false;
    if (el.closest('.rk-ask')) return false;
    return /(^|\s)(kicker|eyebrow)(\s|$)/.test(el.className || '');
  }

  /* The innermost element carrying exactly this text, so a whole card cannot
     match on the strength of its own label. */
  function findExact(label) {
    var hits = [];
    var nodes = document.querySelectorAll(SCAN);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (text(el) !== label || !eligible(el)) continue;
      var inner = false;
      for (var j = 0; j < el.children.length; j++) {
        if (text(el.children[j]) === label) { inner = true; break; }
      }
      if (!inner) hits.push(el);
    }
    return hits;
  }

  function dress(el) {
    if (el.getAttribute('data-rk-t6') === '1') return;
    el.setAttribute('data-rk-t6', '1');
    el.classList.add('rk-t6');

    var slash = document.createElement('span');
    slash.className = 'rk-t6__sl';
    slash.textContent = '//';
    el.insertBefore(slash, el.firstChild);

    var dot = document.createElement('span');
    dot.className = 'rk-t6__dot';
    el.insertBefore(dot, el.firstChild);
  }

  function run() {
    for (var i = 0; i < LABELS.length; i++) {
      var set = findExact(LABELS[i]);
      for (var j = 0; j < set.length; j++) dress(set[j]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  /* Sections animate in, so one late pass catches anything that was not in the
     DOM at first paint. dress() is idempotent. */
  window.addEventListener('load', function () { setTimeout(run, 500); });
})();
